import { render, staticRenderFns } from "./PagesInspirationToplistWidget.vue?vue&type=template&id=4d407b22&"
import script from "./PagesInspirationToplistWidget.vue?vue&type=script&lang=js&"
export * from "./PagesInspirationToplistWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports